import React, { useState, useRef, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Template from "../../component/Template";
import Api from "../../component/Api";
import Select from "react-select";
import { disciplineStyles } from "../../Assets/js/customStyles.js";

// const dummyDisciplineData = [
//   {
//     discipline_id: 1,
//     discipline_name: "Computer Science",
//     college_course_type: "UG",
//   },
//   {
//     discipline_id: 2,
//     discipline_name: "Electronics",
//     college_course_type: "UG",
//   },
//   {
//     discipline_id: 3,
//     discipline_name: "Mechanical Engineering",
//     college_course_type: "PG",
//   },
//   {
//     discipline_id: 4,
//     discipline_name: "Civil Engineering",
//     college_course_type: "UG",
//   },
// ];

const dummyRegistrationCount = {
  totalStudents: 150,
  RegCnt: 145,
  AprCnt: 120,
  AprPrincipal: 85,
};

export default function StudentExamRegistration() {
  const [examid, setExamid] = useState("");
  const [disciplineId, setDisciplineId] = useState("");
  const [disciplinetype, setDisciplinetype] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const tableRef = useRef(null);
  const [exams, setExams] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const [loadingDisciplines, setLoadingDisciplines] = useState(false);
  const [errorDisciplines, setErrorDisciplines] = useState(null);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [students, setStudents] = useState([]);
  const [errorStudents, setErrorStudents] = useState(null);

  // Dummy data
  useEffect(() => {
    const fetchExams = async () => {
      try {
        const { http } = Api();
        const response = await http.get("/College/getEligibleExams");

        const result = response.data;
        console.log("Exams API result:", result);

        if (result?.status) {
          setExams(result.data);
        } else {
          setExams([]);
        }
      } catch (error) {
        console.error("Error fetching exams:", error);
        setExams([]);
      }
    };

    fetchExams();
  }, []);

  const examOptions = exams.map((exam) => ({
    value: exam.examid,
    label: exam.examtitle,
  }));

  // Using dummy data
  const getexamData = exams;
  console.log({ getexamData });
  const registrationcount = dummyRegistrationCount;
  //   const courseListData = dummyCourseListData;

  const handlExamChange = (selected) => {
    setExamid(selected.value);
  };

  useEffect(() => {
    const fetchDisciplines = async () => {
      if (!examid) {
        setDisciplines([]);
        setDisciplineId(""); // Clear selected discipline
        return;
      }

      setLoadingDisciplines(true);
      setErrorDisciplines(null);
      try {
        const { http } = Api();
        const collegeId = localStorage.getItem("collegeid");

        if (!collegeId) {
          setErrorDisciplines("College ID not found");
          setDisciplines([]);
          return;
        }

        const response = await http.get("/College/getDisciplines", {
          params: {
            examid: examid, // Match backend parameter name
            college_id: collegeId, // Match backend parameter name
          },
        });

        // Access the nested data array
        if (response.data?.status && Array.isArray(response.data.data)) {
          setDisciplines(response.data.data);
        } else {
          setDisciplines([]);
        }
      } catch (err) {
        setErrorDisciplines("Failed to fetch disciplines");
        console.error("Error:", err);
        setDisciplines([]);
      } finally {
        setLoadingDisciplines(false);
      }
    };

    fetchDisciplines();
  }, [examid]);

  useEffect(() => {
    const fetchStudents = async () => {
      // Clear students if no discipline selected
      if (!disciplineId || !disciplinetype) {
        setStudents([]);
        return;
      }

      // Don't fetch if no exam selected
      if (!examid) {
        setStudents([]);
        return;
      }

      setLoadingStudents(true);
      setErrorStudents(null);

      try {
        const { http } = Api();
        console.log({ examid });
        console.log({ disciplineId });
        console.log({ disciplinetype });

        const response = await http.get(
          "/College/viewStudentSupplyRegisteredList",
          {
            params: {
              examid: examid,
              discipline_id: disciplineId,
              college_course_type: disciplinetype,
            },
          }
        );

        if (response.data.studentlist) {
          const studentArray = Object.keys(response.data.studentlist).map(
            (apaarNo) => ({
              apaarNo: apaarNo,
              ...response.data.studentlist[apaarNo],
            })
          );
          setStudents(studentArray);
        } else {
          setStudents([]);
          setErrorStudents("No students found");
        }
      } catch (err) {
        // Check if the error message contains "Data not found"
        if (
          err.response?.data?.message?.includes("Data not found") ||
          err.message?.includes("Data not found")
        ) {
          setErrorStudents("No students found");
        } else {
          setErrorStudents("Failed to load students");
        }
        console.error("Error:", err);
        setStudents([]);
      } finally {
        setLoadingStudents(false);
      }
    };

    fetchStudents();
  }, [examid, disciplineId, disciplinetype]);

  const handleDisciplineChange = (selectedOption) => {
    if (selectedOption) {
      const [id, type] = selectedOption.value.split("_");
      setDisciplineId(id);
      setDisciplinetype(type);
      console.log("Selected Discipline:", selectedOption);
    } else {
      setDisciplineId("");
      setDisciplinetype("");
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter data based on search term
  const filteredStudents = students.filter((student) => {
    const search = searchTerm.toLowerCase();

    return (
      search === "" ||
      student.apaarNo.toLowerCase().includes(search) ||
      student.studentname.toLowerCase().includes(search) ||
      student.prn?.toLowerCase().includes(search)
    );
  });

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="my-page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>Student Supplementary/Betterment Application</h5>
                        <div className="buttons-container"></div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div className="table-responsive">
                          <div className="form theme-form">
                            <div className="card-body custom-input">
                              {/* Filters */}
                              <div className="row">
                                <div className="col-md-6">
                                  <label>
                                    Exam<span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    options={examOptions}
                                    value={
                                      examOptions.find(
                                        (opt) => opt.value === examid
                                      ) || null
                                    }
                                    onChange={(selected) => {
                                      handlExamChange(selected);
                                      setExamid(selected.value);
                                    }}
                                    placeholder="Select an exam..."
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label>
                                    Discipline
                                    <span className="errorclr">*</span>
                                  </label>
                                  <Select
                                    id="discipline_id"
                                    name="discipline_id"
                                    options={
                                      disciplines && disciplines.length > 0
                                        ? disciplines
                                            .sort((a, b) =>
                                              a.discipline_name.localeCompare(
                                                b.discipline_name
                                              )
                                            )
                                            .map((discipline) => ({
                                              value: `${discipline.discipline_id}_${discipline.college_course_type}`, // unique
                                              label: discipline.discipline_name, // shown in dropdown
                                              data: discipline,
                                            }))
                                        : []
                                    }
                                    onChange={handleDisciplineChange}
                                    value={
                                      disciplineId && disciplinetype
                                        ? disciplines
                                            .map((discipline) => ({
                                              value: `${discipline.discipline_id}_${discipline.college_course_type}`,
                                              label: discipline.discipline_name,
                                              data: discipline,
                                            }))
                                            .find(
                                              (option) =>
                                                option.value ===
                                                `${disciplineId}_${disciplinetype}`
                                            ) || null
                                        : null
                                    }
                                    placeholder="Select a discipline..."
                                    isSearchable
                                    isClearable
                                    isLoading={loadingDisciplines}
                                    isDisabled={!examid || loadingDisciplines}
                                    // styles={{
                                    //   menuList: (base) => ({
                                    //     ...base,
                                    //     maxHeight: 200, // limits dropdown height
                                    //     overflowY: "auto", // makes it scrollable
                                    //   }),
                                    // }}
                                    styles={disciplineStyles}
                                  />

                                  {errorDisciplines && (
                                    <small className="text-danger">
                                      {errorDisciplines}
                                    </small>
                                  )}
                                </div>
                              </div>

                              {/* Summary Table */}
                              <div className="row m-t-20">
                                <div className="col-md-6">
                                  <label>Search (APAAR / Name / PRN)</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by APAAR, Name or PRN..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                  />
                                </div>
                              </div>
                              {/* Search Bar */}

                              <div className="table-container">
                                {/* Student Details Table */}
                                <table
                                  className="dataTable  ex-v-table"
                                  ref={tableRef}
                                  id="dataTable"
                                >
                                  <thead>
                                    <tr className="bg-primary">
                                      <th scope="col" width="9%">
                                        APAAR/PRN
                                      </th>
                                      <th scope="col" width="10%">
                                        Name
                                      </th>
                                      <th scope="col" width="30%">
                                        Courses
                                      </th>
                                      <th scope="col" width="10%">
                                        Status
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {loadingStudents ? (
                                      <tr>
                                        <td colSpan="4" className="text-center">
                                          <div
                                            className="spinner-border"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        </td>
                                      </tr>
                                    ) : errorStudents ? (
                                      <tr>
                                        <td
                                          colSpan="4"
                                          className="text-center text-danger"
                                        >
                                          {errorStudents}
                                        </td>
                                      </tr>
                                    ) : filteredStudents.length > 0 ? (
                                      filteredStudents.map((student) => {
                                        return (
                                          <tr key={student.apaarNo}>
                                            <td data-label="APAAR Id">
                                              <div className="txt-aln m-b-10">
                                                <span className="badge badge-success text-white rounded-pill">
                                                  <span>✓✓</span>
                                                </span>
                                              </div>
                                              <div className="txt-aln">
                                                {student.apaarNo}/<br></br>
                                                {student.prn}
                                              </div>
                                            </td>

                                            <td
                                              data-label="Name"
                                              className="text-start"
                                            >
                                              {student.studentname}
                                            </td>

                                            <td data-label="">
                                              <div className="treeview">
                                                <ul>
                                                  {student.courses &&
                                                  student.courses.length > 0 ? (
                                                    student.courses.flatMap(
                                                      (course, index) => {
                                                        const entries = [];

                                                        const getRegistrationType =
                                                          (val) => {
                                                            if (val === 2)
                                                              return "Supplementary";
                                                            if (val === 3)
                                                              return "Betterment";
                                                            return "—";
                                                          };

                                                        // THEORY entry
                                                        if (
                                                          course.paper_appearence_theory
                                                        ) {
                                                          const registrationType =
                                                            getRegistrationType(
                                                              course.paper_appearence_theory
                                                            );
                                                          entries.push(
                                                            <li
                                                              key={`${index}-theory`}
                                                              className="ex-v-tab-li-fnt"
                                                            >
                                                              <b>
                                                                {
                                                                  course.paper_identifier
                                                                }
                                                              </b>{" "}
                                                              -{" "}
                                                              {
                                                                course.course_name
                                                              }{" "}
                                                              <span className="text-muted">
                                                                (Theory)
                                                              </span>{" "}
                                                              <span
                                                                className={`badge ms-1 ${
                                                                  registrationType ===
                                                                  "Supplementary"
                                                                    ? "bg-warning"
                                                                    : registrationType ===
                                                                      "Betterment"
                                                                    ? "bg-info"
                                                                    : "bg-secondary"
                                                                }`}
                                                              >
                                                                {
                                                                  registrationType
                                                                }
                                                              </span>
                                                            </li>
                                                          );
                                                        }

                                                        // PRACTICAL entry
                                                        if (
                                                          course.paper_appearence_pract
                                                        ) {
                                                          const registrationType =
                                                            getRegistrationType(
                                                              course.paper_appearence_pract
                                                            );
                                                          entries.push(
                                                            <li
                                                              key={`${index}-pract`}
                                                              className="ex-v-tab-li-fnt"
                                                            >
                                                              <b>
                                                                {
                                                                  course.paper_identifier
                                                                }
                                                              </b>{" "}
                                                              -{" "}
                                                              {
                                                                course.course_name
                                                              }{" "}
                                                              <span className="text-muted">
                                                                (Practical)
                                                              </span>{" "}
                                                              <span
                                                                className={`badge ms-1 ${
                                                                  registrationType ===
                                                                  "Supplementary"
                                                                    ? "bg-warning"
                                                                    : registrationType ===
                                                                      "Betterment"
                                                                    ? "bg-info"
                                                                    : "bg-secondary"
                                                                }`}
                                                              >
                                                                {
                                                                  registrationType
                                                                }
                                                              </span>
                                                            </li>
                                                          );
                                                        }

                                                        return entries;
                                                      }
                                                    )
                                                  ) : (
                                                    <li>
                                                      No courses registered
                                                    </li>
                                                  )}
                                                </ul>
                                              </div>
                                            </td>

                                            <td
                                              className="text-start"
                                              data-label="Status"
                                            >
                                              <span className="badge bg-success text-white">
                                                {student.exam_reg_status ===
                                                "Approved By Principal"
                                                  ? "Registration Completed"
                                                  : student.exam_reg_status ||
                                                    "Approved By Principal"}
                                              </span>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan="4" className="text-center">
                                          {examid && disciplineId
                                            ? "No students found for the selected exam and discipline"
                                            : "Please select an exam and discipline to view students"}
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
